const angular = require('angular');
const app = angular.module('learn-services');

app.factory('Messaging', [function() {
    var self = this;

    /**
     * messaging object
     */
    self.messaging = {
      messages: [],
      addMessage: function(info) {
        self.messaging.messages.push({
          type: info.type || 'information',
          duration: info.duration || null,
          text: info.text,
          link: info.link || null,
          trackstate: info.trackstate || false
        });
      },
      clearMessages: function(type) {
        if (type) {
          var length = self.messaging.messages.length - 1;
          var removed = 0;
          while (length > -1) {
            if (!self.messaging.messages[length]) {
              length--;
              continue;
            }
            if (!self.messaging.messages[length][type]) {
              length--;
              continue;
            }
            self.messaging.messages.splice(length, 1);
            removed++;
          }
          return removed;
        }
        self.messaging.messages.splice(0);
      },
      getMessages: function() {
        return self.messaging.messages;
      },
      removeMessage: function(index) {
        self.messaging.messages.splice(index, 1);
      },
      renderApiResponseErrorCodes: function(response, errorCodeMap) {
        const displayed = new Set(); //only display duplicate error codes once, could change this if we change our error UX
        if (response.errors) {
          for (const error of response.errors) {
            if (error.code in errorCodeMap && !displayed.has(error.code)) {
              //TODO right now this seems to only display the last message added, we should figure out how to render multiple errors
              self.messaging.addMessage({type: 'error', duration: 5, text: errorCodeMap[error.code]});
              displayed.add(error.code);
            }
          }
        }
      }
    };
    return self.messaging;
  }]);